export default "__VITE_ASSET__BjOCozls__"